import React from "react";
import { Skeleton, Space } from "antd";
import { PageContainer, PageHeader, FiltersContainer } from "./ReportEInvoices.styled";

export const ReportEInvoicesLoading: React.FC = () => {
  return (
    <PageContainer>
      <PageHeader>
        <Skeleton.Input active style={{ width: 200, height: 32 }} />
        <Skeleton.Button active style={{ width: 150 }} />
      </PageHeader>

      <FiltersContainer>
        <Space size={16} wrap>
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} style={{ width: 200 }}>
              <Skeleton.Input active size="small" style={{ width: 80, marginBottom: 4 }} />
              <Skeleton.Input active style={{ width: "100%" }} />
            </div>
          ))}
        </Space>
      </FiltersContainer>

      <Skeleton active paragraph={{ rows: 10 }} />
    </PageContainer>
  );
};

